import axios from '@/libs/axios'

/**
 * Factory for crtcreator entity Vuex modules (channels, posts, …).
 */
export default function createCrtcreatorEntityStore({ endpoint }) {
  return {
    namespaced: true,

    state: {
      items: [],
      item: null,
    },

    getters: {
      items(state) {
        return state.items
      },
      item(state) {
        return state.item
      },
    },

    mutations: {
      SET_ITEMS(state, value) {
        state.items = value || []
      },
      SET_ITEM(state, value) {
        state.item = value
      },
      ADD_ITEM(state, data) {
        state.items.unshift(data)
      },
      UPDATE_ITEM(state, data) {
        const index = state.items.findIndex((row) => String(row.id) === String(data.id))
        if (index >= 0) {
          Object.assign(state.items[index], data)
        }
      },
      DELETE_ITEM(state, id) {
        const index = state.items.findIndex((row) => String(row.id) === String(id))
        if (index !== -1) {
          state.items.splice(index, 1)
        }
      },
    },

    actions: {
      loadItems({ commit }) {
        return axios.get(endpoint).then((response) => {
          commit('SET_ITEMS', response.data?.data ?? response.data ?? [])
        })
      },
      loadItem({ commit }, id) {
        return axios.get(`${endpoint}/${id}`).then((response) => {
          const data = response.data?.data ?? response.data
          commit('SET_ITEM', data)
          return data
        })
      },
      addItem({ commit }, payload) {
        return axios.post(endpoint, payload).then((response) => {
          const data = response.data?.data ?? response.data
          commit('ADD_ITEM', data)
          return data
        })
      },
      updateItem({ commit }, { id, payload }) {
        return axios.put(`${endpoint}/${id}`, payload).then((response) => {
          const data = response.data?.data ?? response.data
          commit('UPDATE_ITEM', data)
          return data
        })
      },
      deleteItem({ commit }, id) {
        return axios.delete(`${endpoint}/${id}`).then(() => {
          commit('DELETE_ITEM', id)
        })
      },
    },
  }
}
